import { Card, CardBody } from "reactstrap";

const Campaign = () =>{
    return<Card>
        <CardBody style={{marginTop: '5rem'}}>
            <iframe width="100%" height="620" src="https://lookerstudio.google.com/embed/reporting/4b3de814-54cf-4951-aa3d-df50fd4cd527/page/2T17" frameBorder="0" style={{border:'0'}} allowfullscreen></iframe>
        </CardBody>
    </Card>
}
export default Campaign;